import React from "react";
import { Paper, Stack } from "@mui/material";

function Calendar( {checkins, loadingCheckins } ) {
  const days = ["M", "T", "W", "T", "F", "S", "S"];
  const weeks = 4;

  // Array of YYYY-MM-DD strings for special days
//   const checkinDays = ["2025-08-12", "2025-08-14", "2025-08-25"];
  const checkinDays = checkins.map(checkin => checkin.day);

  // Helper: Monday=0..Sunday=6
  const getMondayIndex = (d) => (d.getDay() + 6) % 7;

  const today = new Date();
  const todayIdx = getMondayIndex(today);

  // Start date so that today is bottom row
  const startDate = new Date(today);
  startDate.setHours(0, 0, 0, 0);
  startDate.setDate(startDate.getDate() - ((weeks - 1) * 7 + todayIdx));

  const gridDates = Array.from({ length: weeks * 7 }, (_, i) => {
    const d = new Date(startDate);
    d.setDate(startDate.getDate() + i);
    return d;
  });

  const isSameDay = (a, b) =>
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate();

  const isHighlighted = (date) => {
    const dateStr = date.toISOString().split("T")[0]; // "YYYY-MM-DD"
    return checkinDays.includes(dateStr);
  };

  return (
    console.log("checkins", checkins),
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        borderRadius: 2.5,
        background: "#fffbff",
        borderColor: "#ffdad4",
        borderWidth: "0px",
      }}
    >
      <Stack direction="column" justifyContent="center" alignItems="center" spacing={2}>
        <Stack direction="column" spacing={1} sx={{ mb: "10px" }}>
          {/* Weekday headers */}
          <Stack direction="row" spacing={1}>
            {days.map((day) => (
              <span
                key={day}
                className="app-font"
                style={{
                  color: "#3f0300",
                  fontWeight: 700,
                  fontSize: "1.0rem",
                  width: 24,
                  textAlign: "center",
                }}
              >
                {day}
              </span>
            ))}
          </Stack>

          {/* Date grid */}
          {Array.from({ length: weeks }, (_, weekIndex) => (
            <Stack key={weekIndex} direction="row" spacing={1}>
              {Array.from({ length: 7 }, (_, dayIndex) => {
                const cellDate = gridDates[weekIndex * 7 + dayIndex];
                const isToday = isSameDay(cellDate, today);
                const highlighted = isHighlighted(cellDate);

                return (
                  <span
                    key={dayIndex}
                    className="app-font"
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 24,
                      height: 24,
                      borderRadius: 6,
                      fontWeight: 400,
                      fontSize: "0.9rem",
                      color: "#3f0300",
                      background: highlighted ? "#ffe066" : "transparent",
                    }}
                    title={cellDate.toDateString()}
                  >
                    {isToday ?
                        <u><b>{cellDate.getDate()}</b></u>
                        :
                        cellDate.getDate()
                    }
                    
                  </span>
                );
              })}
            </Stack>
          ))}
        </Stack>
      </Stack>
    </Paper>
  );
}

export { Calendar };
